import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';

import { AppConfig } from '@project_app/config/app.config';
@Injectable({
    providedIn: 'root'
})

export class PlatformService {

    constructor(
        @Inject(PLATFORM_ID) private platformId: Object
    ) { }

    isBrowser() {
        return isPlatformBrowser(this.platformId);
    }

    isServer() {
        return isPlatformServer(this.platformId);
    }

    isAndroid() {
        if (this.isBrowser()) {
            if (navigator.userAgent) {
                return navigator.userAgent.includes('Android');
            } 
        } 

        return false;
    }

    // To detect if App is Native(Refer: AppConfig.app_userAgent)
    isNativeAppWebView() {

        if (this.isServer()) {
            return false;
        }

        if (navigator && navigator.userAgent && AppConfig.app_userAgent) {

            const userAgent = navigator.userAgent;

            for (let key in AppConfig.app_userAgent) {
                if (userAgent.includes(AppConfig.app_userAgent[key])) {
                    return true;
                }
            }
        }

        return false;
    }

    isSafariBrowser() {
        if (this.isServer()) {
            return false;
        }
        const userAgent = navigator.userAgent
        const isSafariOnIOS = !this.isAndroid() && !/CriOS|FxiOS/.test(userAgent);
        return isSafariOnIOS;
    }
}
